export default __webpack_public_path__ + "static/media/more-services-4.252b1e94.svg";